(function (window, document) {
  'use strict';

  var ANALYSE_VELO_POLL_INTERVAL_MS = 30 * 1000;
  var ANALYSE_VELO_POLL_MAX_MS = 30 * 60 * 1000;

  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function getApi() {
    return window.buybackApi || null;
  }

  function showExpiredToastAndRefetch(self) {
    var toast = window.BuybackPortalToast;
    var msg = t('toast_offer_expired') || 'Cette offre a expiré, la page a été mise à jour.';
    if (toast && typeof toast.info === 'function') {
      toast.info(msg);
    } else {
      try {
        alert(msg);
      } catch (e) {}
    }
    self._loadFromHash();
  }

  // Factorisation 409 stale_data entre accept/refuse. Retourne true si géré
  // (l'appelant doit `return` immédiatement). Cas expiré → toast + refetch ;
  // sinon → reload (fallback rétro-compatible quand `currentStatus` absent).
  function handle409Stale(self, err) {
    if (!err || err.message !== 'HTTP_409') return false;
    if (err.data && err.data.currentStatus === 'proposition_expiree') {
      showExpiredToastAndRefetch(self);
      return true;
    }
    window.location.reload();
    return true;
  }

  class BuybackPortalDetail extends HTMLElement {
    constructor() {
      super();
      this._listeners = [];
      this._currentReprise = null;
      this._pollTimer = null;
      this._pollStartedAt = 0;
      this._onHashChange = null;
      this._onBackClick = null;
      // Anti-race : pendant un click "Modifier" pendant polling, deux _render()
      // peuvent se chevaucher (mutation optimistic + tick polling). On batch
      // via requestAnimationFrame pour ne garder que le dernier état pertinent.
      this._renderQueued = false;
      this._renderPending = null;
      this._renderRafId = null;
    }

    connectedCallback() {
      var self = this;
      // Purge proactive des markers session legacy (T12 cleanup post-suppression signature_pending)
      try {
        Object.keys(sessionStorage)
          .filter(function (k) {
            return k.indexOf('bp:sig:') === 0;
          })
          .forEach(function (k) {
            sessionStorage.removeItem(k);
          });
      } catch (e) {
        /* sessionStorage indisponible */
      }

      this._onHashChange = function () {
        self._loadFromHash();
      };
      this.addEventListener('bp:hash-change', this._onHashChange);

      // Bouton retour vers liste
      var back = this.querySelector('[data-bp-back]');
      if (back) {
        this._onBackClick = function (e) {
          e.preventDefault();
          window.location.hash = '#/list';
        };
        back.addEventListener('click', this._onBackClick);
      }

      this._loadFromHash();
    }

    disconnectedCallback() {
      if (this._onHashChange) {
        this.removeEventListener('bp:hash-change', this._onHashChange);
        this._onHashChange = null;
      }
      var back = this.querySelector('[data-bp-back]');
      if (back && this._onBackClick) {
        back.removeEventListener('click', this._onBackClick);
        this._onBackClick = null;
      }
      this._cleanup();
    }

    _cleanup() {
      this._cancelPendingRender();
      this._stopAnalysePolling();
      this._clearListeners();
    }

    _clearListeners() {
      this._listeners.forEach(function (l) {
        try {
          l.el.removeEventListener(l.event, l.fn);
        } catch (e) {
          /* ignore */
        }
      });
      this._listeners = [];
    }

    _addListener(el, event, fn) {
      if (!el) return;
      el.addEventListener(event, fn);
      this._listeners.push({ el: el, event: event, fn: fn });
    }

    _parseId() {
      var m = window.location.hash.match(/^#\/detail\/(.+)$/);
      return m ? decodeURIComponent(m[1]) : null;
    }

    async _loadFromHash() {
      var id = this._parseId();
      if (!id) return;
      this._cleanup();
      // Anti-FOUC : masquer le contenu tant que le premier render n'a pas eu lieu.
      // Sans ça, le DOM Liquid initial (data-bp-offer-state="pending" = "Analyse du vélo")
      // s'affiche ~200-2000ms avant le swap vers le vrai statut.
      if (!this._hasRendered) this.classList.add('bp-detail--loading');
      var api = getApi();
      if (!api) return;
      try {
        var res = await api.getReprise(id);
        var reprise = (res && res.reprise) || res;
        this._currentReprise = reprise;
        // Backfill sessionStorage : le payload list ne sérialise ni
        // pickup_requested_date ni boutique_hubspot_id, ce qui empêche le
        // substep state d'afficher le bon CTA quick-action sur la liste.
        // Dès qu'on a chargé le detail (payload complet), on persiste un marker.
        try {
          if (reprise && reprise.pickup_requested_date) {
            sessionStorage.setItem('bp:pickup:' + reprise.id, '1');
          }
          if (reprise && reprise.boutique_hubspot_id) {
            sessionStorage.setItem('bp:store:' + reprise.id, '1');
          }
        } catch (e) {
          /* sessionStorage indisponible */
        }
        this._render(reprise);
        // Polling uniquement si analyse en cours
        var slug = reprise.status_slug || reprise.status || '';
        if (slug === 'analyse_velo') {
          this._startAnalysePolling(reprise);
        }
      } catch (err) {
        if (err.message === 'UNAUTHENTICATED') return;
        if (err.message === 'HTTP_404') {
          this._renderError(t('error_404_reprise'));
        } else {
          this._renderError(t('error_generic'));
        }
      }
    }

    // Batche les _render concurrents (mutation optimistic + tick polling)
    // pour éliminer la race "click Modifier pendant polling" qui déclenchait
    // 2 rebuilds successifs avec listeners doublés / aria-expanded incohérent.
    _render(r) {
      var self = this;
      this._renderPending = r;
      if (this._renderQueued) return;
      this._renderQueued = true;
      var hasRaf = typeof window.requestAnimationFrame === 'function';
      var schedule = hasRaf
        ? window.requestAnimationFrame.bind(window)
        : function (cb) {
            return setTimeout(cb, 16);
          };
      this._renderRafId = schedule(function () {
        var pending = self._renderPending;
        self._renderQueued = false;
        self._renderPending = null;
        self._renderRafId = null;
        if (pending) self._renderNow(pending);
      });
    }

    _cancelPendingRender() {
      if (!this._renderRafId) return;
      var cancel =
        typeof window.cancelAnimationFrame === 'function' ? window.cancelAnimationFrame.bind(window) : clearTimeout;
      try {
        cancel(this._renderRafId);
      } catch (e) {}
      this._renderRafId = null;
      this._renderQueued = false;
      this._renderPending = null;
    }

    _renderNow(r) {
      var helpers = window.buybackPortalHelpers;
      if (!helpers) return;
      this._clearListeners();
      if (!window.__buybackMe) {
        try {
          console.warn('[buyback] __buybackMe absent au _render, fallback PART');
        } catch (e) {}
      }
      // Fallback aligné sur la normalisation T17 : PART ou NON_PART (pas 'PRO').
      var vendorType =
        typeof helpers.normalizeVendorType === 'function'
          ? helpers.normalizeVendorType(r, window.__buybackMe || null)
          : window.__buybackMe && window.__buybackMe.vendorType === 'PRO'
            ? 'NON_PART'
            : 'PART';
      var SubstepCls = window.ContractualisationSubstep;
      var substep = SubstepCls ? new SubstepCls(r, vendorType).compute() : 'none';
      var state = helpers.computeStateFromTimeline
        ? helpers.computeStateFromTimeline(r, r.status_slug || r.status || '', substep)
        : helpers.computeStateFromSlug(r.status_slug || r.status || '', substep);

      this._renderRef(r);
      helpers.renderProgress(this, r, state);
      helpers.renderOffer(this, r, substep, state);
      if (typeof helpers.renderOfferCardSelection === 'function') {
        helpers.renderOfferCardSelection(this, r, window.__buybackMe || null, substep, state);
      }
      helpers.renderStepMessage(this, state, substep);
      this._bindActions(r, state, substep);
      // 1er render OK → révéler le contenu (anti-FOUC, cf. _loadFromHash)
      if (!this._hasRendered) {
        this._hasRendered = true;
        this.classList.remove('bp-detail--loading');
      }
    }

    _renderRef(r) {
      var ref = this.querySelector('[data-bp-ref]');
      if (!ref) return;
      var label = r.code_mint || r.reference || '';
      // Évite "DEMANDE #<uuid>" quand seul `r.id` (UUID v4) est disponible :
      // dégrade gracieusement vers "DEMANDE" sans suffixe en attendant le
      // refetch qui rapportera le code_mint humain.
      ref.textContent = label ? 'DEMANDE #' + label : 'DEMANDE';
    }

    _bindActions(r /* , state, substep */) {
      var self = this;
      var accept = this.querySelector('[data-bp-accept]');
      var refuse = this.querySelector('[data-bp-refuse]');
      var showCalc = this.querySelector('[data-bp-show-calc]');
      var pickStore = this.querySelector('[data-bp-pick-store]');
      var selectionModify = this.querySelector('[data-bp-selection-modify]');
      var selectionToggle = this.querySelector('[data-bp-selection-toggle]');
      var uploadDocs = this.querySelector('[data-bp-upload-docs]');

      if (accept && !accept.hidden) {
        this._addListener(accept, 'click', function () {
          self._onAcceptClick(r);
        });
      }
      if (refuse && !refuse.hidden) {
        this._addListener(refuse, 'click', function () {
          self._onRefuseClick(r);
        });
      }
      if (showCalc && !showCalc.hidden) {
        this._addListener(showCalc, 'click', function () {
          self._onShowCalcClick();
        });
      }
      if (pickStore && !pickStore.hidden) {
        this._addListener(pickStore, 'click', function () {
          self._onPickStoreClick(r);
        });
      }
      if (selectionModify) {
        // Branche selon data-action posé par renderOfferCardSelection :
        //   - "store-modify" (PART) → rouvre le flow store (modal méthode + sélection)
        //   - "pickup-modify" (non-PART) → ouvre modal-pickup-date directement
        // Le listener data-bp-pickup-modify était par erreur branché sur
        // _onPickStoreClick (copier-coller incomplet). Fix : router via data-action.
        this._addListener(selectionModify, 'click', function () {
          var action = selectionModify.getAttribute('data-action');
          if (action === 'pickup-modify') {
            self._openPickupDateFlow(r);
          } else {
            self._onPickStoreClick(r);
          }
        });
      }
      if (selectionToggle) {
        this._addListener(selectionToggle, 'click', function () {
          var details = self.querySelector('[data-bp-selection-details]');
          var expanded = selectionToggle.getAttribute('aria-expanded') === 'true';
          var next = !expanded;
          selectionToggle.setAttribute('aria-expanded', next ? 'true' : 'false');
          if (details) details.hidden = !next;
        });
      }
      if (uploadDocs && !uploadDocs.hidden) {
        this._addListener(uploadDocs, 'click', function () {
          self._onUploadDocsClick(r);
        });
      }
    }

    _onAcceptClick(r) {
      var self = this;
      var api = getApi();
      var toast = window.BuybackPortalToast;
      if (!api || !toast) return;
      var codeMint = r.code_mint || r.id;
      toast.confirmWithUndo({
        messageTpl: t('toast_accept_pending_tpl') || 'Offre acceptée — appliqué dans {{ seconds }} s',
        message: t('toast_accept_pending') || 'Offre acceptée — appliqué dans 3 s',
        undoLabel: t('toast_undo') || 'Annuler',
        delayMs: 3000,
        onConfirm: async function () {
          var card = self.querySelector('[data-bp-offer-card]');
          var acceptBtn = self.querySelector('[data-bp-accept]');
          var originalLabel = acceptBtn ? acceptBtn.textContent : '';
          if (acceptBtn) {
            acceptBtn.disabled = true;
            acceptBtn.setAttribute('aria-busy', 'true');
            var spinner = document.createElement('span');
            spinner.className = 'bp-spinner';
            spinner.setAttribute('aria-hidden', 'true');
            var labelNode = document.createTextNode(t('button_accepting') || 'Acceptation en cours…');
            acceptBtn.textContent = '';
            acceptBtn.appendChild(spinner);
            acceptBtn.appendChild(labelNode);
          }
          if (card) card.setAttribute('data-bp-loading', 'true');
          try {
            await api.accept(r.id, {
              code_mint_confirm: codeMint,
              expectedUpdatedAt: r.updatedAt,
            });
            window.location.reload();
          } catch (err) {
            if (handle409Stale(self, err)) return;
            if (acceptBtn) {
              acceptBtn.disabled = false;
              acceptBtn.removeAttribute('aria-busy');
              acceptBtn.textContent = originalLabel;
            }
            if (card) card.removeAttribute('data-bp-loading');
            try {
              alert(t('toast_accept_error') || 'Une erreur est survenue, réessayez.');
            } catch (e) {}
          }
        },
      });
    }

    _onRefuseClick(r) {
      var self = this;
      var modals = window.buybackPortalModals;
      var api = getApi();
      if (!modals || !api) return;
      var codeMint = r.code_mint || r.id;
      modals.openRefuse({
        onConfirm: async function (payload, ctx) {
          var body = {
            code_mint_confirm: codeMint,
            expectedUpdatedAt: r.updatedAt,
            reason_predefined: payload.reason,
          };
          if (payload.comment) body.reason_text = payload.comment;
          if (ctx) ctx.setBusy(true);
          try {
            await api.refuse(r.id, body);
            if (ctx) ctx.setBusy(false);
            modals.closeCurrent();
            window.location.reload();
          } catch (err) {
            if (ctx) ctx.setBusy(false);
            if (err && err.message === 'HTTP_409') {
              modals.closeCurrent();
              if (handle409Stale(self, err)) return;
              return;
            }
            if (ctx && ctx.showError) {
              ctx.showError();
            } else {
              try {
                alert(t('modal_refuse_save_error') || 'Une erreur est survenue, réessayez.');
              } catch (e) {}
            }
          }
        },
      });
    }

    _onShowCalcClick() {
      var modals = window.buybackPortalModals;
      if (!modals) return;
      modals.openCalcPrice();
    }

    _onPickStoreClick(r) {
      var modals = window.buybackPortalModals;
      var helpers = window.buybackPortalHelpers;
      var api = getApi();
      if (!modals || !helpers || !api) return;
      // Branche vendor_type : non-PART → modal pickup-date au lieu du flow store.
      // `_openPickupDateFlow` gère également le fallback 400 forbidden_for_part
      // (race vendor_type) en rebasculant vers le flow store.
      if (typeof helpers.isPart === 'function' && !helpers.isPart(r, window.__buybackMe || null)) {
        return this._openPickupDateFlow(r);
      }
      var self = this;
      var stores = helpers.parseStores(this);
      var MINT = helpers.MINT_DIRECT_STORE_ID;
      var preMethod = helpers.isMintDirectStore(r.boutique_hubspot_id)
        ? 'mint_direct'
        : helpers.isNoStoreNearby && helpers.isNoStoreNearby(r.boutique_hubspot_id)
          ? null
          : r.boutique_hubspot_id
            ? 'shop'
            : null;

      var persistChoice = async function (storeId, ctx) {
        try {
          var expectedUpdatedAt = (self._currentReprise && self._currentReprise.updatedAt) || r.updatedAt;
          var result = await api.persistStoreChoice(r.id, storeId, expectedUpdatedAt);
          if (ctx) ctx.setBusy(false);
          modals.closeCurrent();
          // Toujours refetch via getReprise pour garantir un payload complet
          // (code_mint, offer, timeline). Le payload de /select-store peut être
          // partiel selon le backend — un render direct écrase code_mint/offer/
          // timeline et provoque UUID brut + écran pending + progress 1/1.
          // Le `result.reprise` (déjà filtré strict côté API client) sert
          // d'optimistic update IMMÉDIAT en attendant le refetch.
          //
          // CRUCIAL : on rafraîchit `_currentReprise.updatedAt` même si `reprise`
          // n'est pas wrappé, pour que le prochain POST (ex: "Modifier" rapide
          // après MINT_DIRECT) parte avec le bon expectedUpdatedAt et n'échoue
          // pas avec un 409 stale_data.
          var base = self._currentReprise || r;
          var nextUpdatedAt = result && result.updatedAt;
          if (result && (result.reprise || nextUpdatedAt)) {
            var optimistic = Object.assign({}, base);
            if (result.reprise) Object.assign(optimistic, result.reprise);
            if (nextUpdatedAt) optimistic.updatedAt = nextUpdatedAt;
            self._currentReprise = optimistic;
            self._render(optimistic);
          }
          self._loadFromHash();
        } catch (err) {
          if (ctx) ctx.setBusy(false);
          if (err && err.message === 'INVALID_STORE_ID') return;
          if (ctx && ctx.showError) ctx.showError();
        }
      };

      var openShopStep = function () {
        modals.openStoreSelect(stores, {
          selectedId: null,
          onBack: function () {
            openMethodStep();
          },
          onSelect: function (store, ctx) {
            if (ctx) ctx.setBusy(true);
            persistChoice(store.id, ctx);
          },
          onNoStoreNearby: function (ctx) {
            // AMENDMENT A5: capture dlgRef SYNCHRONEMENT avant l'await pour éviter
            // les races avec changement de modal pendant le POST réseau.
            var dlgRef = modals.getCurrentDialog && modals.getCurrentDialog();
            if (ctx) ctx.setBusy(true);
            var NSN = helpers.NO_STORE_NEARBY_STORE_ID;
            var expectedUpdatedAt = (self._currentReprise && self._currentReprise.updatedAt) || r.updatedAt;
            api
              .persistStoreChoice(r.id, NSN, expectedUpdatedAt)
              .then(function (result) {
                if (ctx) ctx.setBusy(false);
                // Mise à jour optimistic _currentReprise SANS re-render (la modal succès est devant)
                var base = self._currentReprise || r;
                var nextUpdatedAt = result && result.updatedAt;
                if (result && (result.reprise || nextUpdatedAt)) {
                  var optimistic = Object.assign({}, base);
                  if (result.reprise) Object.assign(optimistic, result.reprise);
                  if (nextUpdatedAt) optimistic.updatedAt = nextUpdatedAt;
                  self._currentReprise = optimistic;
                }
                // AMENDMENT A5: vérif que le dialog n'a pas changé pendant l'await
                var dlgNow = modals.getCurrentDialog && modals.getCurrentDialog();
                if (dlgRef && dlgRef === dlgNow && modals.renderNoStoreNearbySuccess) {
                  modals.renderNoStoreNearbySuccess(dlgRef, function onSuccessClose() {
                    // Refetch uniquement quand l'utilisateur ferme la modal succès
                    self._loadFromHash();
                  });
                } else {
                  // Modal fermée/changée pendant l'await : refresh direct
                  self._loadFromHash();
                }
              })
              .catch(function (err) {
                if (ctx) ctx.setBusy(false);
                if (err && err.message === 'INVALID_STORE_ID') return;
                if (ctx && ctx.showError) ctx.showError();
              });
          },
        });
      };

      var openMethodStep = function () {
        modals.openDepotMethodSelect({
          selectedMethod: preMethod,
          onSelectMethod: function (method, ctx) {
            if (method === 'shop') {
              openShopStep();
              return;
            }
            // method === 'mint_direct'
            if (ctx) ctx.setBusy(true);
            persistChoice(MINT, ctx);
          },
        });
      };

      openMethodStep();
    }

    _openPickupDateFlow(r) {
      var self = this;
      var mod = window.buybackPortalModalPickupDate;
      if (!mod || typeof mod.open !== 'function') {
        try {
          console.warn('[bp:detail] buybackPortalModalPickupDate indisponible');
        } catch (e) {}
        return;
      }
      var api = getApi();
      if (!api || typeof api.persistPickupDate !== 'function') {
        try {
          console.warn('[bp:detail] buybackApi.persistPickupDate indisponible');
        } catch (e) {}
        return;
      }
      var helpers = window.buybackPortalHelpers;
      mod.open({
        repriseId: r.id,
        currentDate: r.pickup_requested_date || '',
        currentSlot: r.pickup_requested_slot || '',
        onConfirm: function (isoDate, slot, ctx) {
          var expected = (self._currentReprise && self._currentReprise.updatedAt) || r.updatedAt || null;
          api
            .persistPickupDate(r.id, {
              isoDate: isoDate,
              slot: slot,
              expectedUpdatedAt: expected,
              isPart: false,
            })
            .then(function (result) {
              // Marker session pour que le substep state détecte 'store_chosen'
              // même quand le payload liste ne sérialise pas pickup_requested_date.
              try {
                sessionStorage.setItem('bp:pickup:' + r.id, '1');
              } catch (e) {}
              // Optimistic update (cf. pattern persistStoreChoice) puis refetch.
              var base = self._currentReprise || r;
              var nextUpdatedAt = result && result.updatedAt;
              if (result && (result.reprise || nextUpdatedAt)) {
                var optimistic = Object.assign({}, base);
                if (result.reprise) Object.assign(optimistic, result.reprise);
                if (nextUpdatedAt) optimistic.updatedAt = nextUpdatedAt;
                self._currentReprise = optimistic;
                self._render(optimistic);
              }
              if (ctx && typeof ctx.close === 'function') ctx.close();
              self._loadFromHash();
            })
            .catch(function (err) {
              // Mapping factorisé (helpers.handlePickupDateError) :
              // - HTTP_400+forbidden_for_part → close + refetch + showError + setTimeout(0) qui ré-ouvre
              //   le flow store si la reprise est revenue PART (race vendor_type).
              // - HTTP_400/invalid_payload → invalid_date
              // - HTTP_422/wrong_status → statut figé
              // - HTTP_429 → rate limit
              // - HTTP_409/stale_data → close + refetch (persistPickupDate fait déjà 1 retry interne)
              // - HTTP_403 → géré par api-client (retry me() puis redirect login si échec)
              if (helpers && typeof helpers.handlePickupDateError === 'function') {
                helpers.handlePickupDateError(err, ctx, {
                  onRefresh: function () {
                    self._loadFromHash();
                  },
                  onForbiddenForPart: function () {
                    var hp = window.buybackPortalHelpers;
                    if (
                      self._currentReprise &&
                      hp &&
                      typeof hp.isPart === 'function' &&
                      hp.isPart(self._currentReprise, window.__buybackMe || null)
                    ) {
                      self._onPickStoreClick(self._currentReprise);
                    }
                  },
                });
              } else {
                var showError = ctx && typeof ctx.showError === 'function' ? ctx.showError : null;
                if (showError) showError(t('modal_pickup_date_save_error') || 'Une erreur est survenue.');
              }
            });
        },
      });
    }

    _onUploadDocsClick(r) {
      var modals = window.buybackPortalModals;
      if (!modals) return;
      var helpers = window.buybackPortalHelpers;
      // Source de vérité = helpers.normalizeVendorType (priorité reprise.vendor_type > me.vendorType).
      // Mappe ensuite NON_PART → 'PRO' pour la signature legacy attendue par openDocsUpload (modal-docs.js).
      var normalized =
        helpers && typeof helpers.normalizeVendorType === 'function'
          ? helpers.normalizeVendorType(r, window.__buybackMe || null)
          : window.__buybackMe && window.__buybackMe.vendorType === 'PRO'
            ? 'NON_PART'
            : 'PART';
      var vendorType = normalized === 'NON_PART' ? 'PRO' : 'PART';
      var cfg = window.buybackPortalConfig;
      var rawBase = (cfg && typeof cfg.getApiBaseUrl === 'function' && cfg.getApiBaseUrl()) || '';
      var apiBaseUrl = String(rawBase || '').replace(/\/?$/, '/');
      var self = this;
      modals.openDocsUpload({
        repriseId: r.id,
        vendorType: vendorType,
        apiBaseUrl: apiBaseUrl,
        statusSlug: r.status_slug,
        onAllUploaded: function () {
          self._loadFromHash();
        },
      });
    }

    _startAnalysePolling(r) {
      var self = this;
      this._stopAnalysePolling();
      this._pollStartedAt = Date.now();
      var api = getApi();
      if (!api) return;
      this._pollTimer = setInterval(async function () {
        if (Date.now() - self._pollStartedAt >= ANALYSE_VELO_POLL_MAX_MS) {
          self._stopAnalysePolling();
          return;
        }
        try {
          var res = await api.getReprise(r.id);
          var fresh = (res && res.reprise) || res;
          if (!fresh) return;
          var oldSlug = self._currentReprise ? self._currentReprise.status_slug || self._currentReprise.status : null;
          var newSlug = fresh.status_slug || fresh.status;
          if (newSlug !== oldSlug) {
            self._currentReprise = fresh;
            self._stopAnalysePolling();
            self._render(fresh);
          }
        } catch (e) {
          /* keep polling jusqu'au timeout max */
        }
      }, ANALYSE_VELO_POLL_INTERVAL_MS);
    }

    _stopAnalysePolling() {
      if (this._pollTimer) {
        clearInterval(this._pollTimer);
        this._pollTimer = null;
      }
      this._pollStartedAt = 0;
    }

    _renderError(msg) {
      var ref = this.querySelector('[data-bp-ref]');
      if (ref) ref.textContent = msg || t('error_generic') || 'Erreur';
      // Path erreur : révéler le contenu pour afficher le message
      if (!this._hasRendered) {
        this._hasRendered = true;
        this.classList.remove('bp-detail--loading');
      }
    }
  }

  if (!customElements.get('buyback-portal-detail')) {
    customElements.define('buyback-portal-detail', BuybackPortalDetail);
  }
})(window, document);
